<div [ngClass]="menuActive ? 'active' : ''">
  @if (showDealerItems || mobile) {
    <span
      id="menuButton"
      class="dropdown-toggle ms-2 ms-sm-0"
      data-toggle="dropdown"
      (click)="openMenu()"
      placement="bottom"
      [ngbTooltip]="'MENU' | translate"
      >
      <i id="menuButtonIcon" class="material-icons">
        {{ !menuActive ? "menu" : "close" }} </i
        ><span class="glyphicon glyphicon-chevron-down pull-right"></span>
      </span>
    }

    @if (menuActive && deviceDetector.isMobile()) {
      <app-mobile-navigation
        [browseGroups]="browseGroups"
        [menuItems]="generalItems"
        [settingsItems]="settingsItems"
        (gotoItemEvent)="menuActive = false; gotoItem($event)"
        (closeMenuEvent)="menuActive = false"
      ></app-mobile-navigation>
    }

    <!-- Container overlay -->
    @if (!deviceDetector.isMobile()) {
      <ul
        (clickOutside)="closeMenu($event)"
        id="userBar-parent"
        class="py-0 border-0 dropdown-menu mega-dropdown-menu row start-0 userBar-parent position-absolute"
    [ngClass]="[
      menuHovered ? 'hovered' : '',
      menuActive ? 'active' : 'inActive'
    ]"
        >
        <li
          class="px-0 mx-0 col-sm-12 row userBar dark"
          id="userBar-menu"
          [ngClass]="menuActive ? 'active' : 'inActive'"
          >
          <!-- Menu bar -->
          <div
            class="container"
            (mouseenter)="menuHovered = true"
            (mouseleave)="menuHovered = false"
            >
            @if (browseGroups && browseGroups.length) {
              <div
                ngbDropdown
                class="dropdownContainer d-none d-sm-inline-block browse-groups"
                (mouseenter)="showCatalogHover()"
                (click)="toggleMenuItem(showCatalog, $event)"
                (clickOutside)="showCatalog['active'] = false"
                (mouseleave)="hideCatalogHover()"
                >
                <button
                  class="py-2 ps-0 btn generalItem topItem dropdown-toggle"
                  id="generalItemCatalog"
                  >
                  {{ "CATALOG" | translate }}
                </button>
                <div
                  ngbDropdownMenu
                  [ngClass]="showCatalog['active'] ? 'show' : ''"
                  class="mt-0"
                  >
                  @if (testC) {
                    <app-catalogue-dropdown
                      [browseGroups]="browseGroups"
                      (groupSelected)="groupSelectedFromNavbar($event)"
                      (hide)="showCatalog['active'] = false"
              [showBom]="
                companyGroupsSettings &&
                companyGroupsSettings.bom_companies &&
                companyGroupsSettings.bom_companies.length
              "
                    ></app-catalogue-dropdown>
                  }
                  @if (!testC) {
                    @for (articleGroup of browseGroups; track articleGroup) {
                      <button
                        class="p-0 dropdown-item"
                        [ngClass]="articleGroup.sub_items ? 'withSubmenu' : ''"
                        >
                        <!-- Dropdown in dropdown-->
                        @if (
                          articleGroup.sub_items && articleGroup.sub_items.length
                          ) {
                          <button
                            class="p-0 btn generalItem"
                            [id]="articleGroup.name"
                            >
                            <span
                              class="w-100 d-block dropdown-toggle"
                              style="padding: 0.375rem 0.75rem"
                              (click)="selectGroup($event, articleGroup.name)"
                              >
                              <span class="d-inline-block" style="width: 95%">{{
                                articleGroup.description
                              }}</span>
                            </span>
                            @if (articleGroup.sub_items) {
                              <div
                                ngbDropdown
                                placement="right"
                                style="right: 0"
                                class="d-inline-block position-absolute"
                                >
                                @if (
                                  articleGroup.sub_items &&
                                  articleGroup.sub_items.length
                                  ) {
                                  <div
                                    ngbDropdownMenu
                        [ngClass]="
                          articleGroup.sub_items.length > 15 ? 'xl-menu' : ''
                        "
                                    >
                                    <div
                          [ngClass]="
                            articleGroup.sub_items.length > 15 ? 'row mx-0' : ''
                          "
                                      >
                                      @for (productGroup of articleGroup.sub_items; track productGroup) {
                                        @if (!productGroup.sub_items) {
                                          <button
                                            class="px-3 py-1 dropdown-item w-100"
                              [ngClass]="
                                articleGroup.sub_items.length > 15
                                  ? 'col-6'
                                  : ' w-100'
                              "
                              (click)="
                                selectGroup(
                                  $event,
                                  articleGroup.name,
                                  productGroup.name
                                )
                              "
                                            >
                                            <span>{{ productGroup.description | translate }}</span>
                                          </button>
                                        }
                                        @if (productGroup.sub_items) {
                                          <div
                              [ngClass]="
                                articleGroup.sub_items.length > 15
                                  ? 'col-6'
                                  : ''
                              "
                                            class="px-0"
                                            >
                                            @if (productGroup.sub_items) {
                                              <button
                                                ngbDropdownToggle
                                                class="px-3 text-sub dropdown-item position-relative w-100 d-inline-block"
                                                (mouseenter)="productGroup.active = true"
                                                (mouseleave)="productGroup.active = false"
                                                >
                                                <span
                                                  class="position-absolute w-100 h-100"
                                                  style="top: 0; left: 0"
                                  (click)="
                                    selectGroup(
                                      $event,
                                      articleGroup.name,
                                      productGroup.name
                                    )
                                  "
                                                ></span>
                                                <span
                                                  class="my-2"
                                  (click)="
                                    selectGroup(
                                      $event,
                                      articleGroup.name,
                                      productGroup.name
                                    )
                                  "
                                                  class="d-inline-block"
                                                  style="width: 95%"
                                                  >{{ productGroup.description | translate }}
                                                </span>
                                                @if (productGroup.sub_items) {
                                                  <div
                                                    ngbDropdown
                                                    placement="right"
                                                    class="d-inline-block position-absolute subGroups deepest"
                                                    style="right: 0"
                                                    >
                                                    @if (
                                                      productGroup.active &&
                                                      productGroup.sub_items
                                                      ) {
                                                      <div
                                                        ngbDropdownMenu
                                    [ngClass]="
                                      productGroup.sub_items.length > 15
                                        ? 'xl-menu'
                                        : ''
                                    "
                                                        >
                                                        <div
                                                          class="d-flex flex-column"
                                      [ngClass]="
                                        productGroup.sub_items.length > 15
                                          ? 'row mx-0'
                                          : ''
                                      "
                                                          >
                                                          @for (
                                                            subgroupItem of productGroup.sub_items
                                                            ; track
                                                            subgroupItem) {
                                                            @if (!subgroupItem.sub_items) {
                                                              <button
                                                                class="dropdown-item w-100"
                                          [ngClass]="
                                            productGroup.sub_items.length > 15
                                              ? 'col-6'
                                              : ' w-100'
                                          "
                                          (click)="
                                            selectGroup(
                                              $event,
                                              articleGroup.name,
                                              productGroup.name,
                                              subgroupItem.name
                                            )
                                          "
                                                                >
                                                                {{ subgroupItem.description | translate }}
                                                              </button>
                                                            }
                                                            @if (subgroupItem.sub_items) {
                                                              <button
                                                                ngbDropdownToggle
                                                                class="px-3 text-sub dropdown-item position-relative w-100 d-inline-block"
                                          (mouseenter)="
                                            subgroupItem.active = true
                                          "
                                          (mouseleave)="
                                            subgroupItem.active = false
                                          "
                                                                >
                                                                <span
                                                                  class="position-absolute w-100 h-100"
                                                                  style="top: 0; left: 0"
                                            (click)="
                                              selectGroup(
                                                $event,
                                                articleGroup.name,
                                                productGroup.name,
                                                subgroupItem.name
                                              )
                                            "
                                                                ></span>
                                                                <span
                                                                  class="my-2"
                                            (click)="
                                              selectGroup(
                                                $event,
                                                articleGroup.name,
                                                productGroup.name,
                                                subgroupItem.name
                                              )
                                            "
                                                                  class="d-inline-block"
                                                                  style="width: 95%"
                                                                  >{{ subgroupItem.description | translate }}
                                                                </span>
                                                                @if (subgroupItem.sub_items) {
                                                                  <div
                                                                    ngbDropdown
                                                                    placement="right"
                                                                    class="d-inline-block position-absolute subGroups deepest"
                                                                    style="right: 0"
                                                                    >
                                                                    @if (
                                                                      subgroupItem.active &&
                                                                      subgroupItem.sub_items
                                                                      ) {
                                                                      <div
                                                                        ngbDropdownMenu
                                                                        >
                                                                        @for (
                                                                          subSubgroupItem of subgroupItem.sub_items
                                                                          ; track
                                                                          subSubgroupItem) {
                                                                          @if (
                                                                            !subSubgroupItem.sub_items
                                                                            ) {
                                                                            <button
                                                                              class="dropdown-item w-100"
                                                  [ngClass]="
                                                    productGroup.sub_items
                                                      .length > 15
                                                      ? 'col-6'
                                                      : ' w-100'
                                                  "
                                                  (click)="
                                                    selectGroup(
                                                      $event,
                                                      articleGroup.name,
                                                      productGroup.name,
                                                      subgroupItem.name,
                                                      subSubgroupItem.name
                                                    )
                                                  "
                                                                              >
                                                                              {{
                                                                              subSubgroupItem.description
                                                                              }}
                                                                            </button>
                                                                          }
                                                                        }
                                                                      </div>
                                                                    }
                                                                  </div>
                                                                }
                                                              </button>
                                                            }
                                                          }
                                                        </div>
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                              </button>
                                            }
                                          </div>
                                        }
                                      }
                                      <button
                                        class="px-3 py-1 dropdown-item btn fw-bold w-100 d-flex align-items-center"
                                        (click)="selectGroup($event, articleGroup.name)"
                                        >
                                        <i class="material-icons">chevron_right</i>
                                        {{ "VIEW_ALL" | translate }}
                                      </button>
                                    </div>
                                  </div>
                                }
                              </div>
                            }
                          </button>
                        }
                        <!-- Normal item -->
                        @if (!articleGroup.sub_items) {
                          <button
                            class="py-2 btn generalItem"
                            [id]="articleGroup.name"
                            (click)="currentLeftItem = articleGroup.name; gotoSearch()"
                            >
                            {{ articleGroup.description | translate }}
                          </button>
                        }
                      </button>
                    }
                    @if (
                      companyGroupsSettings &&
                      companyGroupsSettings.bom_companies &&
                      companyGroupsSettings.bom_companies.length
                      ) {
                      <button
                        class="px-0 py-0 dropdown-item"
                        (click)="gotoSearchPage('CMN_OLD,CMN_BOM', $event)"
                        >
                        <button class="btn generalItem">{{ "BOM" | translate }}</button>
                      </button>
                    }
                  }
                </div>
              </div>
            }
            @for (item of generalItems; track item) {
              @if (item.sub_items) {
                <div
                  ngbDropdown
                  class="d-inline-block dropdownContainer"
                  [ngClass]="item.class"
                  style="position: relative"
                  [ngClass]="[item.active ? 'show' : '']"
                  #myDrop="ngbDropdown"
                  (mouseenter)="openMenuItem(item)"
                  (mouseleave)="dontopenMenuItem(item)"
                  (click)="toggleMenuItem(item, $event)"
                  (clickOutside)="item.active = false"
                  (mouseleave)="item.active = false"
                  [id]="'parent_' + item.name"
                  >
                  <button
                    class="py-0 btn generalItem topItem dropdown-toggle ps-0"
                    [id]="item.name"
                    [innerHTML]="getDescription(item) | translate"
                    [class.fw-bold]="item.name === 'promotions'"
              (mouseenter)="
                item.name === 'promotions' ? loadPromotions() : undefined
              "
              (click)="
                item.name === 'promotions'
                  ? gotoSearchPage('CMN_PROM', $event)
                  : undefined
              "
                  ></button>
                  <!-- Dropdown -->
                  <div
                    ngbDropdownMenu
              [ngClass]="[
                item.active ? 'show' : '',
                item.name === 'usersettings' ? 'userDropdown' : ''
              ]"
                    class="mt-0"
                    >
                    @if (
                      promotions &&
                      !promotions.length &&
                      !promotionsLoaded &&
                      item.name === 'promotions'
                      ) {
                      <button class="px-3 py-1 dropdown-item btn">
                        @if (
                          promotions && !promotions.length && !promotionsLoaded
                          ) {
                          <span
                            class="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        }
                      </button>
                    }
                    @if (
                      promotions && promotions.length && item.name === 'promotions'
                      ) {
                      @for (groupedPromotions of promotions; track groupedPromotions) {
                        @for (promotion of groupedPromotions; track promotion) {
                          <button
                            class="px-0 py-2 dropdown-item"
                            >
                            <button
                              class="py-0 btn generalItem"
                      [innerHTML]="
                        promotion.title === ''
                          ? promotion.promotioncode
                          : promotion.title
                      "
                      (click)="
                        gotoSearchPage(
                          'CMN_PROM&HOMEPROMO=' +
                            promotion.promotioncode +
                            '&COMPANY=' +
                            +promotion.company_id,
                          $event
                        );
                        item.active = false
                      "
                            ></button>
                          </button>
                        }
                      }
                    }
                    @if (item.name === 'usersettings' && accounts?.length > 1) {
                      <div class="p-2 d-block">
                        <span
                          class="btn btn-light"
                          (click)="selectLinkedAccountModal()"
                          >{{ "SELECT_ACCOUNT" | translate }}</span
                          >
                        </div>
                      }
                      @if (isAdmin && item.name === 'usersettings') {
                        <div class="p-2 d-block">
                          <span
                            class="btn btn-light d-inline-flex align-items-center"
                            [routerLink]="'/' + companyGroupCode + '/admin/'"
                            >
                            <i class="material-icons me-1"> admin_panel_settings </i>
                            Admin tools</span
                            >
                          </div>
                        }
                        @for (subitem of item.sub_items; track subitem) {
                          <button
                            class="px-0 py-0 dropdown-item"
                            [ngClass]="subitem.sub_items ? 'withSubmenu' : ''"
                            >
                            <!-- Dropdown in dropdown-->
                            @if (subitem.sub_items && showOption(subitem.name)) {
                              <button
                                class="py-2 btn generalItem dropdown-toggle"
                                [id]="subitem.name"
                                on-mouseover="myDropSub ? myDropSub.open() : null"
                                >
                                <span
                                  class="d-inline-block"
                                  (click)="subitem.url ? gotoItem(subitem) : null"
                                  style="width: 95%; min-width: 200px"
                                  >{{ subitem.description | translate }}</span
                                  >
                                  @if (subitem.sub_items) {
                                    <div
                                      ngbDropdown
                                      placement="right"
                                      class="d-inline-block subDropdown"
                                      style="position: relative"
                                      #myDropSub="ngbDropdown"
                                      >
                                      @if (subitem.sub_items) {
                                        <div ngbDropdownMenu>
                                          @for (subsubitem of subitem.sub_items; track subsubitem) {
                                            <button
                                              class="p-0 dropdown-item"
                          [ngClass]="[
                            subsubitem.sub_items ? 'withSubmenu' : ''
                          ]"
                          (click)="
                            item.active = false;
                            myDropSub.close()
                          "
                                              >
                                              <!-- Dropdown in dropdown-->
                                              @if (
                                                subsubitem.sub_items &&
                                                showOption(subsubitem.name)
                                                ) {
                                                <button
                                                  class="p-2 btn generalItem dropdown-toggle last"
                                                  [id]="subsubitem.name"
                            on-mouseover="
                              deepestDropdown ? deepestDropdown.open() : null
                            "
                                                  >
                                                  <span
                                                    class="d-inline-block"
                              (click)="
                                subsubitem.url ? gotoItem(subsubitem) : null
                              "
                                                    style="width: 95%; min-width: 200px"
                                                    >{{ subsubitem.description | translate }}</span
                                                    >
                                                    @if (subsubitem.sub_items) {
                                                      <div
                                                        ngbDropdown
                                                        placement="right"
                                                        class="deepestDropdown"
                                                        style="position: relative; display: none"
                                                        #deepestDropdown="ngbDropdown"
                                                        >
                                                        @if (subsubitem.sub_items) {
                                                          <div
                                                            ngbDropdownMenu
                                                            style="margin-left: 10px; margin-top: -20px"
                                                            >
                                                            @for (
                                                              deepestItem of subsubitem.sub_items
                                                              ; track
                                                              deepestItem) {
                                                              <button
                                                                class="py-2 dropdown-item"
                                  (click)="
                                    gotoItem(deepestItem); item.active = false
                                  "
                                                                >
                                                                {{ deepestItem.description | translate }}
                                                              </button>
                                                            }
                                                          </div>
                                                        }
                                                      </div>
                                                    }
                                                  </button>
                                                }
                                                <!-- Normal item -->
                                                @if (
                                                  !subsubitem.sub_items &&
                                                  showOption(subsubitem.name)
                                                  ) {
                                                  <button
                                                    class="p-2 btn generalItem"
                                                    [id]="subsubitem.name"
                                                    (click)="gotoItem(subsubitem); item.active = false"
                                                    >
                                                    {{ subsubitem.description | translate }}
                                                  </button>
                                                }
                                              </button>
                                            }
                                          </div>
                                        }
                                      </div>
                                    }
                                  </button>
                                }
                                <!-- Normal item -->
                                @if (!subitem.sub_items && showOption(subitem.name)) {
                                  <button
                                    class="py-2 btn generalItem"
                                    [id]="subitem.name"
                                    (click)="gotoItem(subitem); item.active = false"
                                    >
                                    {{ subitem.description | translate }}
                                  </button>
                                }
                              </button>
                            }
                            @if (item.name === 'usersettings') {
                              <button class="px-0 py-0 dropdown-item">
                                <button
                                  class="py-2 btn generalItem"
                                  (click)="logout($event); item.active = false"
                                  >
                                  {{ "LOGOUT" | translate }}
                                </button>
                              </button>
                            }
                            <button
                              class="py-2 text-end btn generalItem w-100 fw-bold d-sm-none d-inline-block"
                              (click)="item.active = false"
                              >
                              {{ "CLOSE" | translate }}
                            </button>
                          </div>
                        </div>
                      }
                      @if (!item.sub_items) {
                        <button
                          class="py-0 btn generalItem topItem"
                          [attr.id]="item.name"
                          (click)="gotoItem(item)"
                          >
                          {{ item.description | translate }}
                        </button>
                      }
                    }
                    @if (helpPageId[companyGroupCode]) {
                      <button
                        class="py-0 btn generalItem topItem"
          [routerLink]="
            companyGroupCode +
            '/companyPage/' +
            this.helpPageId[companyGroupCode]
          "
                        >
                        {{ "CMS_SERVICE_AYUDA_ACCENTRY" | translate }}
                      </button>
                    }
                    @if (companyGroupCode === 'COM' && currentCountryCode=='FR' ) {
                      <button class="py-0 btn generalItem topItem"
        [routerLink]="
            companyGroupCode +
             '/companyPage/eco-contribution'">{{ "ECOTAX" | translate }}
                      </button>
                    }
                    @if (promotionPageId[companyGroupCode]) {
                      <button
                        class="py-0 btn generalItem topItem"
          [routerLink]="
            companyGroupCode +
            '/companyPage/' +
            this.promotionPageId[companyGroupCode]
          "
                        >
                        {{ "OFFERS" | translate }}
                      </button>
                    }
                    @if ((accountInformation?.can_access_rakoo) || (applicationService.getSelectCompanyGroupCode() === 'RAL' && showDealerItems)) {
                      <div ngbDropdown class="d-inline-block dropdownContainer" (mouseleave)="showDropdown = false">
                        <button
                          class="py-0 btn generalItem topItem ps-0"
                          (mouseenter)="showDropdown = true"
                          ngbDropdownToggle
                          >
                          <span class="material-icons me-1">school</span> Accell Academy
                        </button>
                        <div ngbDropdownMenu class="mt-0"  [ngClass]="showDropdown ? 'show' : ''">
                          <button class="dropdown-item" (click)="getRakooLearningUrl()">
                            {{"START_RAKOO_TRAINING"|translate}}
                          </button>
                          @if (!['COM'].includes(applicationService.getSelectCompanyGroupCode())) {
                            <button class="dropdown-item" (click)="gotoRakoo()">
                              {{"RAKOO_STORE"|translate}}
                            </button>
                          }
                          @if (applicationService.getSelectCompanyGroupCode() !== 'RAL') {
<button class="dropdown-item"  [routerLink]="
            companyGroupCode +
            '/companyPage/' + (academyPageId[companyGroupCode] || 'accell-academy-explanation')
          ">
                              {{"EXPLANATION_ACCELL_ACADEMY"|translate}}
                            </button>
                          }
                          @if (applicationService.getSelectCompanyGroupCode() === 'RAL') {
<button class="dropdown-item" [routerLink]="
            companyGroupCode +
            '/companyPage/accell-academy-uk'
          ">
                              {{"WELCOME_TO_ACADEMY"|translate}}
                            </button>
                          }
                                @if (applicationService.getSelectCompanyGroupCode() === 'RAL') {
<button class="dropdown-item" (click)="gotoExternalUrl('https://e-learnings.accellacademy.com/login')">
                              {{"GO_TO_ACADEMY_EMPLOYEE"|translate}}
</button>
                          }
                        </div>
                      </div>
                    }
                    <!-- XLC Menu Item -->
                    @if (hasXLC && xlcCompanyPageId[companyGroupCode]) {
                      <button
                        class="py-0 btn generalItem topItem ps-0"
                        [routerLink]="companyGroupCode + '/companyPage/' + xlcCompanyPageId[companyGroupCode]"
                        >
                        XLC
                      </button>
                    }
                    @if (hasPreorder) {
                      <button
                        class="px-0 py-0 btn generalItem topItem px-sm-2 highlightedButton"
                        id="preorderButton"
                        (click)="gotoPreorder()"
                        (mouseenter)="popoverPreorder.open()"
                        placement="bottom"
                        #popoverPreorder="ngbPopover"
                        popoverClass="popoverPreorder"
          [disablePopover]="
            !showPreorderPopover ||
            (preorderBasket && !preorderBasket.items.length)
          "
                        [ngbPopover]="popContent"
                        [popoverTitle]="'PREORDER_BASKET' | translate"
                        >
                        {{ "PREORDER" | translate }}
                      </button>
                    }
                    @if ((companyGroupCode === 'RAL' || companyGroupCode === 'LAP') && showDealerItems && !['GHO','WG'].includes(companyGroupCode)) {
                      <div
                        ngbDropdown
                        class="d-inline-block dropdownContainer"
                        [ngClass]="showPromotionsDropdown ? 'show' : ''"
                        (mouseenter)="getPromotions(); showPromotionsDropdown = true"
                        (mouseleave)="showPromotionsDropdown = false"
                        >
                        <button
                          type="button"
                          class="py-0 btn generalItem topItem dropdown-toggle ps-0 ps-xl-1 fw-bold"
                          id="dropdownPromotions"
                          ngbDropdownToggle
                          >
                          {{ "PROMOTIONS" | translate }}
                        </button>
                        <div
                          ngbDropdownMenu
                          class="mt-0"
                          [ngClass]="showPromotionsDropdown ? 'show' : ''"
                          aria-labelledby="dropdownPromotions"
                          >
                          @if (promotions && !promotions.length && !promotionsLoaded) {
                            <button class="px-3 py-1 dropdown-item btn">
                              <span
                                class="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>
                            </button>
                          }
                          @for (groupedPromotions of promotions; track groupedPromotions) {
                            @for (promotion of groupedPromotions; track promotion) {
                              <button
                                class="px-3 py-1 dropdown-item btn"
                [innerHTML]="
                  promotion.title === ''
                    ? promotion.promotioncode
                    : promotion.title
                "
                (click)="
                  gotoSearchPage(
                    'CMN_PROM&HOMEPROMO=' +
                      promotion.promotioncode +
                      '&COMPANY=' +
                      +promotion.company_id,
                    $event
                  );
                  showPromotionsDropdown = false
                "
                              ></button>
                            }
                          }
                          <div class="px-0 py-0 dropdown-item">
                            @if (promotionsLoaded) {
                              <button
                                class="px-3 py-1 generalItem btn fw-bold d-flex align-items-center"
                (click)="
                  gotoSearchPage('CMN_PROM', $event);
                  showPromotionsDropdown = false
                "
                                >
                                <i class="material-icons">chevron_right</i>
                                {{ "VIEW_ALL" | translate }}
                              </button>
                            }
                          </div>
                        </div>
                      </div>
                    }
                    <!-- Top-level PROMOTIONS for GHO and WG -->
                    @if (['GHO', 'WG', 'TUN'].includes(companyGroupCode) && showDealerItems && companyGroupsSettings?.promotion_companies?.length && !showroomMode) {
                      <div
                        ngbDropdown
                        class="d-inline-block dropdownContainer"
                        [ngClass]="showPromotionsDropdown ? 'show' : ''" (mouseenter)="getPromotions(); showPromotionsDropdown = true"
                        (mouseleave)="showPromotionsDropdown = false"
                        >
                        <button
                          type="button"
                          class="py-0 btn generalItem topItem dropdown-toggle ps-1 ps-xl-2 fw-bold"
                          ngbDropdownToggle
                          >
                          {{ "PROMOTIONS" | translate }}
                        </button>
                        <div
                          ngbDropdownMenu
                          class="mt-0"
                          [ngClass]="showPromotionsDropdown ? 'show' : ''"
                          >
                          <div class="px-3 py-1 text-white small fw-bold text-uppercase opacity-75">{{ "PROMOTIONS_BIKES" | translate }}</div>
                          @if (promotions && !promotions.length && !promotionsLoaded) {
                            <button class="px-3 py-1 dropdown-item btn">
                              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            </button>
                          }
                          @for (groupedPromotions of promotions; track groupedPromotions) {
                            @for (promotion of groupedPromotions; track promotion) {
                              <button
                                class="px-3 py-1 dropdown-item btn"
                                [hidden]="promotion.company_id != 101 && companyGroupCode === 'WG'"
                                [innerHTML]="promotion.title === '' ? promotion.promotioncode : promotion.title"
                (click)="gotoSearchPage('CMN_PROM&HOMEPROMO=' + promotion.promotioncode + '&COMPANY=' + +promotion.company_id, $event); showPromotionsDropdown = false"
              ></button>
}
            
}
            @if (promotionsLoaded && ((companyGroupCode === 'WG' && applicationService.checkIfDealerHasCompany(101)) || companyGroupCode !== 'WG')) {
                            <div class="px-0 py-0 dropdown-item">
                              <button
                                class="px-3 py-1 generalItem btn fw-bold d-flex align-items-center"
                                (click)="gotoSearchPage(promotionPageUrl[companyGroupCode + '_BIKES'], $event); showPromotionsDropdown = false"
                                >
                                <i class="material-icons">chevron_right</i>
                                {{ "VIEW_ALL" | translate }}
                              </button>
                            </div>
                          }
                          <!-- WG Parts promotions -->
                          @if (companyGroupCode === 'WG' && applicationService.checkIfDealerHasCompany(102)) {
                            <div class="dropdown-divider"></div>
                            <div class="px-3 py-1 text-white small fw-bold text-uppercase mt-3 opacity-75">{{ "PROMOTIONS_PARTS" | translate }}</div>
                            @if (promotions && !promotions.length && !promotionsLoaded) {
                              <button class="px-3 py-1 dropdown-item btn">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                              </button>
                            }
                            @for (groupedPromotions of promotions; track groupedPromotions) {
                              @for (promotion of groupedPromotions; track promotion) {
                                <button
                                  class="px-3 py-1 dropdown-item btn"
                                  [hidden]="promotion.company_id != 102"
                                  [innerHTML]="promotion.title === '' ? promotion.promotioncode : promotion.title"
                (click)="gotoSearchPage('CMN_PROM&HOMEPROMO=' + promotion.promotioncode + '&COMPANY=' + +promotion.company_id, $event); showPromotionsDropdown = false"
              ></button>
}
            
}
              <div class="px-0 py-0 dropdown-item">
                <button
                  class="px-3 py-1 generalItem btn fw-semibold d-flex align-items-center"
                  (click)="gotoSearchPage('CMN_PROM&groups=14&categories=Parts_&_Accessories', $event); showPromotionsDropdown = false"
                                >
                                <i class="material-icons">chevron_right</i>
                                {{ "VIEW_ALL" | translate }}
                              </button>
                            </div>
                          }
                        </div>
                      </div>
                    }
                    @if (showDealerItems) {
                      <button
                        class="px-0 py-0 btn generalItem topItem search-menu-button px-sm-2 find"
                        (click)="openSearch()"
                        >
                        <i class="material-icons search-icon">search</i>
                      </button>
                    }
                    <ng-template #popContent>
                      @if (preorderBasket) {
                        <span
                          class="mb-2 justify-content-between d-flex"
                          >
                          <span class="pt-2 me-2"
                            >{{ "ARTICLES" | translate }} ({{ "BICYCLES" | translate }}):
                            {{ preorderBasket.items.length }}</span
                            >
                            <button
                              class="ms-1 btn btn-primary btn-sm"
              [routerLink]="
                applicationService.getSelectCompanyGroupCode() +
                '/preorderBasket/Bikes/' +
                preorderBasket.id
              "
                              >
                              {{ "VIEW" | translate }}
                            </button>
                          </span>
                        }
                        @if (preorderBasketParts) {
                          <span
                            class="justify-content-between d-flex"
                            >
                            <span class="pt-2 me-2"
                              >{{ "ARTICLES" | translate }} ({{ "PARTS" | translate }}):
                              {{ preorderBasketParts.items.length }}</span
                              >
                              <button
                                class="ms-1 btn btn-primary btn-sm"
              [routerLink]="
                applicationService.getSelectCompanyGroupCode() +
                '/preorderBasket/Parts/' +
                preorderBasketParts.id
              "
                                >
                                {{ "VIEW" | translate }}
                              </button>
                            </span>
                          }
                        </ng-template>
                      </div>
                    </li>
                    <li class="border-bottom ps-xxl-4">
                      <app-catalogue-navbar
                        [browseGroups]="browseGroups"
                        (groupSelected)="groupSelectedFromNavbar($event)"
        [showBom]="
          companyGroupsSettings &&
          companyGroupsSettings.bom_companies &&
          companyGroupsSettings.bom_companies.length
        "
                      ></app-catalogue-navbar>
                    </li>
                    @if (menuActive) {
                      <!-- Company groups -->
                      <li
                        class="pt-2 col-sm-3 col-md-3 col-lg-3 col-xl-2 companyGroupList"
                        [@pageAnimations]
                        >
                        <ul class="companyGroups ani-item">
                          @for (company of availableCompanyGroups; track company) {
                            <li
                              (click)="setCompanyGroup($event, company.company_group_code)"
              [ngClass]="{
                active:
                  (companyGroupCode == 'WG' &&
                    company.company_group_code === 'WG') ||
                  (companyGroupCode === company.company_group_code &&
                    companyGroupCode !== 'WG')
              }"
                              class="my-1 overflow-auto clickable withOpacity d-flex align-items-center"
                              >
                              <img
                [src]="
                  './assets/images/logos/' +
                  company.company_group_code.toLowerCase() +
                  '.png'
                "
                                />
                              {{ company.company_group_name.default }}
                            </li>
                          }
                          <!-- Add E.WBP as company group if applicable -->
                          @if (hasEWBP) {
                            <li
                              (click)="setCompanyGroup($event, 'WG')"
              [ngClass]="
                companyGroupCode === 'WG' &&
                applicationService.checkIfDealerHasCompany(101 && 102)
                  ? 'active'
                  : ''
              "
                              class="my-1 overflow-auto clickable withOpacity"
                              >
                              <img [src]="'./assets/images/logos/e-wbp.png'" />
                              E. Wiener Bike Parts
                            </li>
                          }
                        </ul>
                      </li>
                      <!-- Article groups -->
                      @if (browseGroups && browseGroups.length) {
                        <li
                          class="col-sm-3 col-md-3 col-lg-2 scrollable ps-2 mt-0 customScrollbar groupContainer g-1"
                          [@pageAnimations]
                          >
                          <h3 class="ani-item">{{ "CATALOG" | translate }}</h3>
                          <ul class="list-group list-group-flush ani-item bg-transparent">
                            @for (item of browseGroups; track item) {
                              <li
                                class="list-group-item py-0 px-0 bg-transparent"
                                >
                                <a
                                  style="margin-left: -0.25rem"
                                  class="ps-1 text-decoration-none"
                                  href="#"
              (click)="
                currentLeftItem =
                  currentLeftItem !== item.name
                    ? (currentLeftItem = item.name)
                    : '';
                selectArticleGroup($event, item)
              "
                                  [ngClass]="currentLeftItem === item.name ? 'active' : ''"
                                  >{{ item.description | translate }}</a
                                  >
                                </li>
                              }
                              @if (
                                showDealerItems &&
                                companyGroupsSettings &&
                                companyGroupsSettings.promotion_companies?.length
                                ) {
                                <li
                                  (click)="gotoSearchPage('CMN_PROM', $event)"
                                  class="list-group-item py-0 px-0 bg-transparent"
                                  >
                                  <a
                                    href="#"
                                    style="margin-left: -0.25rem"
                                    class="ps-1 text-decoration-none"
                                    (click)="gotoSearchPage('CMN_PROM', $event)"
                                    >
                                    {{ "PROMOTIONS" | translate }}
                                  </a>
                                </li>
                              }
                              @if (
                                companyGroupsSettings &&
                                companyGroupsSettings.bom_companies &&
                                companyGroupsSettings.bom_companies.length
                                ) {
                                <li
                                  class="list-group-item py-0 px-0 bg-transparent"
                                  >
                                  <a
                                    href="#"
                                    style="margin-left: -0.25rem"
                                    class="ps-1 text-decoration-none"
                                    (click)="gotoSearchPage('CMN_OLD,CMN_BOM', $event)"
                                    >
                                    {{ "BOM" | translate }}
                                  </a>
                                </li>
                              }
                            </ul>
                          </li>
                        }
                        <!-- Product groups -->
                        @if (currentLeftItem !== '') {
                          <li
                            class="col-sm-3 col-md-3 col-lg-2 scrollable customScrollbar groupContainer overlay g-2"
                            [@enterAnimation]
                            >
                            <ul class="list-group list-group-flush">
                              <li
                                (click)="currentLeftItem = ''; back($event)"
                                id="back1"
                                class="my-2 btn btn-sm btn-primary d-block d-sm-none back list-group-item py-0 px-0 ani-item bg-transparent"
                                >
                                {{ "BACK" | translate }}
                              </li>
                              @for (item of selectedArticleGroups; track item) {
                                <li
                                  class="list-group-item py-0 px-0 ani-item bg-transparent"
                                  >
                                  <a
                                    href="#"
                                    style="margin-left: -0.25rem"
                                    class="ps-1 text-decoration-none"
                                    [ngClass]="currentCenterItem === item.name ? 'active' : ''"
              (click)="
                currentCenterItem = item.name;
                selectProductGroup($event, item, false)
              "
                                    >{{ item.description | translate }}
                                  </a>
                                </li>
                              }
                              <li class="list-group-item py-0 ps-0 ani-item bg-transparent">
                                @if (selectedArticleGroups.length > 1) {
                                  <button
                                    class="btn btn-block btn-dark mt-2 d-flex align-items-center"
                                    (click)="viewAllFromArticleGroup($event)"
                                    >
                                    <i class="material-icons">chevron_right</i>
                                    {{ "VIEW_ALL" | translate }}
                                  </button>
                                }
                              </li>
                            </ul>
                          </li>
                        }
                        <!-- Sub groups -->
                        @if (currentCenterItem !== '') {
                          <li
                            class="col-xs-12 col-sm-3 col-md-3 col-lg-5 scrollable customScrollbar groupContainer overlay g-3 bg-transparent"
                            >
                            <ul class="list-group list-group-flush">
                              <li
                                (click)="currentCenterItem = ''; back($event)"
                                id="back2"
                                class="my-2 btn btn-sm btn-primary d-block d-sm-none back list-group-item py-0 px-0 ani-item bg-transparent"
                                >
                                {{ "BACK" | translate }}
                              </li>
                              @for (item of selectedArticleSubGroups; track item) {
                                <li
                                  class="list-group-item py-0 px-0 ani-item bg-transparent"
                                  >
                                  <a
                                    href="#"
                                    (click)="selectSubGroup($event, item)"
                                    class="text-decoration-none"
                                    >
                                    {{ item.description | translate }}
                                  </a>
                                </li>
                              }
                              <li class="list-group-item py-0 px-0 ani-item bg-transparent">
                                <button
                                  class="btn btn-block btn-dark mt-2 d-flex align-items-center"
                                  (click)="viewAllFromArticleGroup($event)"
                                  >
                                  <i class="material-icons">chevron_right</i>
                                  {{ "VIEW_ALL" | translate }}
                                </button>
                              </li>
                            </ul>
                          </li>
                        }
                        @if (currentLeftItem === '') {
                          <li
                            class="d-none d-sm-block col-sm-2 col-lg-1"
                          ></li>
                        }
                        <!-- Quicklinks  -->
                        <li
                          class="col-xs-12 col-sm-4 col-lg-3 scrollable customScrollbar quickLinks"
                          [style.display]="currentLeftItem === '' ? 'block' : 'none'"
                          [@pageAnimations]
                          >
                          <h3 class="ani-item">{{ "QUICKLINKS" | translate }}</h3>
                          <app-quick-links
                            [homepageQuicklinks]="false"
                            (linkClicked)="menuActive = false"
                            >
                          </app-quick-links>
                        </li>
                      }
                    </ul>
                  }
                </div>
